import MenuVariaveisSalesbox from "../MenuVariaveisSalesbox";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PalavraChaveDemografica from "../PalavraChaveDemografica";
import PesquisaArtigo from "../PesquisaArtigo";

export default function VariaveisDemograficas() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <a href="/variaveis-salesbox">Variáveis Sales Box</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Variáveis demográficas
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuVariaveisSalesbox />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">Variáveis demográficas</h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Variáveis Sales Box</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Entenda nossas variáveis
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  Variáveis demográficas são características estatísticas que
                  descrevem uma população em termos de sua composição, como
                  idade, sexo, etnia, estado civil, nível de educação, renda,
                  ocupação, localização geográfica, entre outros.
                </p>

                <p>
                  São utilizadas em diversas áreas, incluindo marketing,
                  pesquisa de mercado, sociologia, saúde pública e planejamento
                  urbano, para compreender melhor a estrutura e as
                  características de diferentes grupos de pessoas, auxiliando na
                  tomada de decisões e na criação de estratégias direcionadas.
                </p>

                <p>
                  Na
                  <a href="https://salesbox.com.br/" target="blank">
                    <a className="nav-item"> Sales Box</a>
                  </a>
                  , essas variáveis podem se utilizadas tanto na
                  <a
                    href="/como-criar-uma-segmentacao-de-clientes"
                    target="blank"
                  >
                    <a className="nav-item"> Segmentação de Clientes </a>
                  </a>
                  como na criação de um
                  <a href="/como-criar-um-publico-potencial" target="blank">
                    <a className="nav-item"> Público Potencial</a>
                  </a>
                  .
                </p>

                <p>
                  Importante ressaltar que, para as variáveis de escala númerica
                  utilizamos a progressão gradual, ou seja, à medida que nos
                  movemos de 1 para 100 ou de 1 para 1000, há uma tendência
                  geral de aumento na positividade ou veracidade dos números.
                </p>

                <p>
                  <h3 id="renda">Renda</h3>
                </p>

                <p>Veja os tipos de renda que você pode utilizar.</p>

                <p>
                  <a id="rendafamiliar" style={{ fontWeight: "bold" }}>
                    {" "}
                    1. Renda Familiar:{" "}
                  </a>
                  Utilize essa variável aplicando um modelo de renda familiar
                  presumida.
                </p>

                <p>Escala: Moeda.</p>

                <figure>
                  <img
                    src="img/renda-familiar-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="rendaindividual" style={{ fontWeight: "bold" }}>
                    {" "}
                    2. Renda Individual:{" "}
                  </a>
                  Utilize essa variável aplicando um modelo de renda individual
                  presumida.
                </p>

                <p>Escala: Moeda.</p>

                <figure>
                  <img
                    src="img/renda-individual-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <h3 id="dados-basicos">Dados Cadastrais Básicos</h3>
                </p>

                <p>
                  Veja os tipos de dados cadastrais básicos que você pode
                  utilizar.
                </p>

                <p>
                  <a id="sexo" style={{ fontWeight: "bold" }}>
                    {" "}
                    1. Sexo:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potêncial de acordo com os sexos masculino, feminino ou que
                  estão como indefinidos na base de dados.
                </p>

                <p>Escala: "Masculino", "Feminino", "Indefinido".</p>

                <figure>
                  <img src="img/sexo-publico-potencial.png" alt="integracao" />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="idade" style={{ fontWeight: "bold" }}>
                    {" "}
                    2. Idade:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potêncial de acordo com uma determinada faixa etária.
                </p>

                <p>Escala: Faixa etária.</p>

                <figure>
                  <img src="img/idade-publico-potencial.png" alt="integracao" />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <h3 id="dados-avancados">Dados Cadastrais Avançados</h3>
                </p>

                <p>
                  Veja os tipos de dados cadastrais avançados que você pode
                  utilizar.
                </p>

                <p>
                  <a id="profissao" style={{ fontWeight: "bold" }}>
                    {" "}
                    1. Profissão:{" "}
                  </a>
                  Utilize essa variável para segmentar ou criar um público
                  potencial de acordo com uma determinada profissão.
                </p>

                <p>Escala: Profissões.</p>

                <figure>
                  <img
                    src="img/profissao-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="obito" style={{ fontWeight: "bold" }}>
                    {" "}
                    2. Óbito:{" "}
                  </a>
                  Utilize essa variável para detectar óbito do detentor do CPF,
                  ajudando na identificação de possíveis fraudes, por exemplo.
                </p>

                <p>Escala: "Sim", "Não".</p>

                <figure>
                  <img src="img/obito-publico-potencial.png" alt="integracao" />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="peprelacionado" style={{ fontWeight: "bold" }}>
                    {" "}
                    3. Qtde PEP relacionado:{" "}
                  </a>
                  Utilize essa variável para detectar quantidade de pessoas
                  relacionadas ao titular que possui algum vínculo com pessoas
                  politicamente expostas (agentes públicos que desempenham ou
                  tenham desempenhado, nos últimos cinco anos, cargos, empregos
                  ou funções públicas relevantes).
                </p>

                <p>Escala: Número entre 1 e 100.</p>

                <figure>
                  <img
                    src="img/qtde_pep_relacionado_publico_potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="receitafed" style={{ fontWeight: "bold" }}>
                    {" "}
                    4. Status Receita Federal:{" "}
                  </a>
                  Utiize essa variável para segmentar ou criar um público
                  potencial de acordo com a situação cadastral na receita.
                </p>

                <p>
                  Escala: "Cancelada", "Nula", "Pendente de regularização",
                  "Regular", "Suspensa", "Titular falecido".
                </p>

                <figure>
                  <img
                    src="img/status-receita-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="estadocivil" style={{ fontWeight: "bold" }}>
                    {" "}
                    5. Estado Civil:{" "}
                  </a>
                  Utiize essa variável para segmentar ou criar um público
                  potencial de acordo com o status do estado civil.
                </p>

                <p>
                  Escala: "Casado(a)", "Divorciado(a)", "Solteiro(a)",
                  "Viúvo(a)", "Outros".
                </p>

                <figure>
                  <img
                    src="img/estado-civil-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="aponsentado" style={{ fontWeight: "bold" }}>
                    {" "}
                    6. Aponsentado:{" "}
                  </a>
                  Utiize essa variável para segmentar ou criar um público
                  potencial de acordo com o status de aponsentadoria.
                </p>

                <p>Escala: "Sim", "Não".</p>

                <figure>
                  <img
                    src="img/aposentado-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="participacao" style={{ fontWeight: "bold" }}>
                    {" "}
                    7. Participação em Empresas:{" "}
                  </a>
                  Utiize essa variável para segmentar ou criar um público
                  potencial que possui ou não participação em empresas.
                </p>

                <p>Escala: "Sim", "Não".</p>

                <figure>
                  <img
                    src="img/participacao-empresas-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="bolsafamilia" style={{ fontWeight: "bold" }}>
                    {" "}
                    8. Bolsa Familia:{" "}
                  </a>
                  Utiize essa variável para segmentar ou criar um público
                  potencial que possui ou não o benefício do Bolsa Família.
                </p>

                <p>Escala: "Sim", "Não".</p>

                <figure>
                  <img
                    src="img/bolsa-familia-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="auxilio" style={{ fontWeight: "bold" }}>
                    {" "}
                    9. Auxílio Emergencial:{" "}
                  </a>
                  Utiize essa variável para segmentar ou criar um público
                  potencial que possui ou não o benefício do Auxílio
                  Emergencial.
                </p>

                <p>Escala: "Sim", "Não".</p>

                <figure>
                  <img
                    src="img/auxilio-emergencial-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="flagpep" style={{ fontWeight: "bold" }}>
                    {" "}
                    10. Flag PEP:{" "}
                  </a>
                  Utiize essa variável para segmentar ou criar um público
                  potencial que está na relação de Pessoas Expostas Publicamente
                  (agentes públicos que desempenham ou tenham desempenhado, nos
                  últimos cinco anos, cargos, empregos ou funções públicas
                  relevantes).
                </p>

                <p>Escala: "Sim", "Não".</p>

                <figure>
                  <img
                    src="img/fleg-pep-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <p>
                  <a id="escolaridade" style={{ fontWeight: "bold" }}>
                    {" "}
                    11. Escolaridade:{" "}
                  </a>
                  Utiize essa variável para segmentar ou criar um público
                  potencial com base na sua escolaridade.
                </p>

                <p>
                  Escala: "Doutorado", "Ensino fundamental", "Ensino médio",
                  "Ensino médio/técnico", "Ensino superior", "Metrado", "Pós
                  doutorado", "Graduação".
                </p>

                <figure>
                  <img
                    src="img/escolaridade-publico-potencial.png"
                    alt="integracao"
                  />
                </figure>

                <figcaption>Exemplo - Público Potencial</figcaption>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <a>
                <MenuInicioRapido />
              </a>
              <br></br>
              <br></br>
              <small>
                <PalavraChaveDemografica />
              </small>
            </div>
          </div>
        </div>

        {showScrollButton && (
          <a onClick={scrollToTop} className="btn-topo">
            <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
          </a>
        )}
      </section>
      <Footer />
    </>
  );
}
